module.exports = angular.module('cartographer.common.ui.attachment.thumbnail', [])

_ = require 'underscore'

module.exports.directive 'crtAttachmentThumbnail', $DI (crtLog, $window, crtAttachment, crtModal) ->
  return {
    restrict: 'A'
    template: require './thumbnail.tpl.html'
    require: [ 'crtAttachmentThumbnail', '^?crtAttachmentGallery' ]
    controllerAs: 'crtAttachmentThumbnail'
    bindToController: true
    scope:
      localId              : '='
      attachment           : '='
      uploadInfo           : '=?'
      caption              : '@?' # or('title', 'created')
      thumbnailUrlOverride : '=?' # or(string (-> string))
    controller: $DI ->
      crtAttachmentThumbnail = this

      # or('title', 'created')
      crtAttachmentThumbnail.caption ?= 'title'

      # -> boolean
      crtAttachmentThumbnail.showProgressBar = ->
        crtAttachmentThumbnail.uploadInfo?.progress? ||
        crtAttachmentThumbnail.uploadInfo?.success?  ||
        crtAttachmentThumbnail.uploadInfo?.error?

      # Show a lightbox for the specified attachment:
      crtAttachmentThumbnail.thumbnailClicked = () ->
        attach = crtAttachmentThumbnail.attachment

        buttons = []

        buttons.push {
          value: 'download'
          label: 'Download'
          class: 'btn btn-info'
        }

        buttons.push {
          value: 'ok'
          label: 'OK'
          class: 'btn btn-primary'
        }

        if crtAttachmentThumbnail.canDelete(attach)
          buttons.push {
            value: 'delete'
            label: 'Delete'
            class: 'btn btn-danger pull-left'
          }

        crtModal.alert
          title:   attach.filename
          content: """
                   <a href="#{crtAttachment.resolveOriginal(attach)}" target="_blank">
                     <img class="lightbox-image" src="#{crtAttachment.resolvePreview(attach)}" alt="#{attach.title}">
                   </a>
                   """
          buttons: buttons
        .then (value) ->
          switch value
            when 'delete'   then crtAttachmentThumbnail.deleteUpload(attach)
            when 'download' then $window.location = crtAttachment.resolveOriginal(attach)
          return

      crtAttachmentThumbnail.thumbnailUrl = ->
        crtAttachmentThumbnail.thumbnailUrlOverride ? crtAttachment.resolveThumbnail(crtAttachmentThumbnail.attachment)

      crtAttachmentThumbnail.deleteClicked = ->
        crtAttachmentThumbnail.deleteUpload()

      return
    link: ($scope, element, attrs, controllers) ->
      [ crtAttachmentThumbnail, crtAttachmentGallery ] = controllers

      crtAttachmentThumbnail.canDelete = ->
        crtAttachmentGallery?.canDelete()

      crtAttachmentThumbnail.deleteUpload = ->
        crtAttachmentGallery?.deleteUpload(crtAttachmentThumbnail.localId)
        return

      return
  }
